import supabase from '../supabase/supabase';

const MAILER_ENDPOINT = `${supabase.supabaseUrl}/functions/v1/send-enquiry-email`;

export async function requestEmail(payload) {
  if (!MAILER_ENDPOINT) {
    return { ok: false, error: 'Email service is not configured. Set VITE_MAILER_ENDPOINT to your secure mail endpoint.' };
  }

  try {
    const { data: { session } } = await supabase.auth.getSession();
    const response = await fetch(MAILER_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'apikey': supabase.supabaseKey, 'Authorization': `Bearer ${session?.access_token || supabase.supabaseKey}` },
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      return { ok: false, error: `Email service returned ${response.status}.` };
    }
    return { ok: true };
  } catch {
    return { ok: false, error: 'Could not reach the email service.' };
  }
}

export function isEmailServiceConfigured() {
  return Boolean(MAILER_ENDPOINT);
}